import { render, staticRenderFns } from "./ImportItem.vue?vue&type=template&id=f5e012c6&scoped=true"
import script from "./ImportItem.vue?vue&type=script&lang=js"
export * from "./ImportItem.vue?vue&type=script&lang=js"
import style0 from "./ImportItem.vue?vue&type=style&index=0&id=f5e012c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e012c6",
  null
  
)

export default component.exports